import React, { useEffect, useState } from 'react';
import {
  Card,
  Input,
  message,
  Modal,
  Typography,
  Row,
  Col,
  Select,
  Form,
  Button
} from 'antd';
import PageHeader from '../../components/PageHeader/PageHeader';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';
import useAuthContext from '../../contexts/AuthContext';
import Logo from '../../assets/images/logo-assurmax.png';
import TracfinLogo1 from '../../assets/images/tracfin-logo_1.jpg';
import TracfinLogo2 from '../../assets/images/tracfin-logo_2.png';
import ContentCustom from '../../components/ContentCustom/ContentCustom';

const TracfinLink = styled.a`
  color: var(--clientColor);
  line-height: 2;
  font-weight: bold;

  &:hover {
    color: var(--primaryColor);
  }
`;

const { Option } = Select;
const { Search } = Input;

const category = ['siret', 'company_name', 'email', 'phone_number'];

const Tracfin = () => {
  const { t } = useTranslation();
  const { dispatchAPI, user } = useAuthContext();
  const [registers, setRegisters] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [description, setDescription] = useState('');
  const [title, setTitle] = useState('');
  const [customerOk, setCustomerOk] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [selectedCategory, setselectedCategory] = useState();
  const [form] = Form.useForm();

  const searchCategory = {
    siret: { message: t('errors.form.SIRET'), len: 14 },
    company_name: { message: t('errors.form.EMAIL.REQUIRED') },
    email: { type: 'email', message: t('errors.form.EMAIL') },
    phone_number: { message: t('errors.form.PHONE'), len: 10 }
  };

  const getSearchResponse = async (values) => {
    try {
      const customer = { customer: values };
      const { data } = await dispatchAPI('POST', {
        url: `/tracfin/${user?._id}?precise=true`,
        body: customer
      });
      setRegisters(data);
      setIsModalVisible(!isModalVisible);
      setLoading(false);
    } catch (e) {
      if (e.response) message.error(e.response.status);
    }
  };

  useEffect(() => {
    if (registers.length) {
      setTitle('Attention');
      setDescription(
        "V positif - Nous vous informons que votre requête semble être positive. Nous vous demandons de ne pas souscrire de contrat, nous prendrons contact avec vous très rapidement.\n Pour débloquer votre devis, ou contrat nous vous invitons à nous faire parvenir une pièce d'identité de votre prospect sur courtiers@assurmaxpro.com"
      );
    } else {
      setTitle('Rien à signaler');
      setDescription(
        'X négatif - Nous vous informons que votre requête est négative. Aucune restriction de souscription.'
      );
    }
  }, [registers]);

  const onSearch = async (values) => {
    if (values) {
      setLoading(!loading);
      await getSearchResponse(values);
    }
  };

  const onSearchBlackList = async (value) => {
    setLoading2(true);
    setCustomerOk(false);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/blackList/check?${selectedCategory}=${value}`
      });
      setIsSearch(true);
      if (data && data.status === 'BLACK') {
        setCustomerOk(false);
      } else {
        setCustomerOk(true);
      }
    } catch (e) {
      if (e.response) message.error(e.response.status);
    }
    setLoading2(false);
  };

  const isReductScreen = useMediaQuery({ query: '(max-width: 1600px)' });
  const isSmallScreen = useMediaQuery({ query: '(max-width: 1200px)' });
  const isXSScreen = useMediaQuery({ query: '(max-width: 490px)' });

  return (
    <>
      <Modal
        title={title}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(!isModalVisible)}
        closable
        footer={false}
      >
        {description}
        <br />
        <span>
          La Direction
          <img alt="Logo" style={{ fontSize: 18 }} src={Logo} />
        </span>
      </Modal>
      <PageHeader title={t('tracfin.search')} />
      <ContentCustom>
        <Row style={{ height: 'auto' }}>
          <Col xxl={8} xs={24} style={{ height: 'auto' }}>
            <Card
              style={{
                border: 'none',
                borderRadius: isReductScreen ? '10px 10px 0 0' : '10px 0 0 0',
                height: '100%'
              }}
            >
              <Typography.Paragraph>
                <span style={{ marginRight: 8 }}>{t('tracfin.label')}</span>
              </Typography.Paragraph>
              <div
                style={{
                  fontStyle: 'italic'
                }}
              >
                <div>{t('tracfin.popover_1')}</div>
                <div>{t('tracfin.popover_2')}</div>
                <div>{t('tracfin.popover_3')}</div>
              </div>
              <Form onFinish={onSearch} style={{ marginTop: 30 }}>
                <Form.Item name="first_name" rules={[{ required: true }]}>
                  <Input placeholder={t('contacts.form.first_name')} />
                </Form.Item>
                <Form.Item name="last_name" rules={[{ required: true }]}>
                  <Input placeholder={t('contacts.form.last_name')} />
                </Form.Item>
                <Form.Item name="company_name">
                  <Input placeholder={t('customers.form.company_name')} />
                </Form.Item>
                <Form.Item
                  style={{ width: isXSScreen ? 200 : '100%', marginTop: 16 }}
                >
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: 150, float: 'right' }}
                    loading={loading}
                  >
                    {t('buttons.validate')}
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
          <Col xxl={16} xs={24}>
            <Card
              style={{
                border: 'none',
                borderRadius: isReductScreen ? 0 : '0 10px 0 0',
                height: '100%'
              }}
            >
              <Typography.Paragraph>{t('tracfin.info')}</Typography.Paragraph>
              <div style={{ fontStyle: 'italic' }}>
                {t('tracfin.definition_1')}
                &nbsp;
                {t('tracfin.definition_2')}
              </div>
              <TracfinLink
                target="_blank"
                rel="noopener noreferrer"
                href="https://acpr.banque-france.fr/sites/default/files/medias/documents/20210402_lcbft_courtiers_assurance.pdf"
              >
                {t('tracfin.link')}
              </TracfinLink>
            </Card>
          </Col>
        </Row>
        <Row
          style={{
            height: 'auto',
            background: 'var(--componentBackground)',
            paddingBottom: isXSScreen ? 24 : 40,
            borderRadius: '0 0 10px 10px'
          }}
        >
          <Col
            xl={8}
            xs={0}
            style={{
              height: 'auto',
              padding: isReductScreen ? 24 : 36,
              alignItems: 'center',
              justifyContent: 'center',
              display: isSmallScreen ? 'none' : 'flex'
            }}
          >
            <img
              src={TracfinLogo1}
              alt="Logo de TRACFIN"
              style={{ width: isReductScreen ? 200 : 260 }}
            />
          </Col>
          <Col
            xl={16}
            xs={24}
            style={{
              height: 'auto',
              padding: isReductScreen ? 24 : 36,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <img
              src={TracfinLogo2}
              alt="Logo de TRACFIN"
              style={{ width: isReductScreen ? 180 : 250 }}
            />
          </Col>
        </Row>
      </ContentCustom>
      <PageHeader title={t('blackList.title')} />
      <ContentCustom>
        <Row style={{ minHeight: 200 }}>
          <Col xxl={8} xs={24} style={{ height: 'auto' }}>
            <Card
              style={{
                border: 'none',
                borderRadius: isReductScreen ? '10px 10px 0 0' : '10px 0 0 0',
                height: '100%'
              }}
            >
              <div style={{ paddingBottom: '10px' }}>
                {t('blackList.check_text')}
              </div>
              <Typography.Paragraph>{t('blackList.find')}</Typography.Paragraph>
              <Form form={form}>
                <Form.Item name={['selectedCategory']}>
                  <Select
                    style={{ width: isXSScreen ? 200 : 300, marginTop: 16 }}
                    placeholder={t('blackList.placeholder_select')}
                    onChange={(cat) => setselectedCategory(cat)}
                  >
                    {category.map((cat) => (
                      <Option value={cat} key={cat}>
                        {t(`blackList.${cat}`)}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="search"
                  rules={[
                    {
                      required: true,
                      type: searchCategory[selectedCategory]?.type,
                      message: searchCategory[selectedCategory]?.message,
                      len: searchCategory[selectedCategory]?.len
                    }
                  ]}
                >
                  {selectedCategory ? (
                    <Search
                      onSearch={onSearchBlackList}
                      style={{ width: isXSScreen ? 200 : 300, marginTop: 16 }}
                      placeholder={t(
                        `blackList.placeholder_${selectedCategory}`
                      )}
                      loading={loading2}
                    />
                  ) : (
                    []
                  )}
                </Form.Item>
              </Form>
            </Card>
          </Col>
          <Col xxl={16} xs={24} style={{ minHeight: 'auto' }}>
            <Card
              style={{
                border: 'none',
                borderRadius: isReductScreen ? '10px 10px 0 0' : '10px 0 0 0',
                height: '100%'
              }}
            >
              {customerOk && isSearch && (
                <Typography.Paragraph>
                  <span style={{ marginRight: 8, color: 'green' }}>
                    {t('blackList.labelOk')}
                  </span>
                </Typography.Paragraph>
              )}
              {!customerOk && isSearch && (
                <Typography.Paragraph>
                  <span style={{ marginRight: 8, color: 'red' }}>
                    {t('blackList.labelNotOK')}
                  </span>
                </Typography.Paragraph>
              )}
            </Card>
          </Col>
        </Row>
      </ContentCustom>
    </>
  );
};

export default Tracfin;
